import React, {Component} from 'react'
import { Table } from 'react-bootstrap'
import { Field } from 'redux-form'

const columns = [
  {name:'File Name',width:260},
  {name:'File Pattern',width:250},
  {name:'Delimiter',width:75},
  {name:'',width:26}
]
let totalWidth = 0;
columns.forEach((c)=>{
  totalWidth += c.width
})
const styles={
  th:{
    display:'inline-block'
  },
  td:{
    display:'inline-block',
    padding:0,
    height:28
  },
  nameColumn:{
    fontWeight:'bold',
    color:'white'
  },
  nameText:{
    overflow:'hidden',
    textOverflow:'ellipsis',
    whiteSpace:'nowrap',
    display:'inline-block',
    verticalAlign:'top',
    marginTop:4
  },
  svg:{
    display:'inline-block',
    verticalAlign:'top',
    margin:5
  },
  input:{
    borderRadius:0,
    height:27,
    border:'none'
  }
}

class FileTable extends Component { 

  constructor(){
    super()
    this.state={
      hovering:null
    }
  }

  render(){
    const {files,inputs,mode,removeFile} = this.props
    return(
      <Table bordered condensed style={{width:totalWidth+2}}>
        <thead>
          <tr>
            {columns.map((c,i)=><th key={i} style={{...styles.th,width:c.width}}>{c.name}</th>)}
          </tr>
        </thead>
        <tbody className="file-table-tbody">
          {files && files.map((file, i) => {
            const del = this.state.hovering===i
            return (<tr key={i}>
              <td style={{...styles.td,...styles.nameColumn,width:columns[0].width,
                background:del?'grey':'#337ab7'}}>
                <FileIcon style={styles.svg}/>
                <span style={{...styles.nameText,maxWidth:columns[0].width-30}}>
                  {file.name}
                </span>
              </td>
              <td style={{...styles.td,width:columns[1].width}}>
                <Field name={`${mode}FileSchema.${i}.filePattern`} 
                  type="text" component={inputs.rfInput} placeholder="File Pattern"
                  style={{...styles.input,width:columns[1].width-1,color:del?'grey':'black'}} />
              </td>
              <td style={{...styles.td,width:columns[2].width}}>
                <Field name={`${mode}FileSchema.${i}.delimiter`} 
                  type="text" component={inputs.rfInput} placeholder="Delimiter"
                  style={{...styles.input,width:columns[2].width-1,color:del?'grey':'black'}} />
              </td>
              <td style={{...styles.td,width:columns[3].width}}>
                <svg className="remove-file-process" viewBox="0 0 60 60"
                  onClick={()=>removeFile(file, i)}
                  onMouseEnter={()=>this.setState({hovering:i})}
                  onMouseLeave={()=>this.setState({hovering:null})}>
                  <path style={{strokeWidth:5, strokeLinecap: 'round'}}
                    d="M 15.674663,15.572746 L 44.587629,44.485711 M 45.118838,15.420972 L 15.522889,45.016920"></path>
                </svg>
              </td>
            </tr>)}
          )}
        </tbody>
      </Table>
    )
  }
}

export default FileTable

const FileIcon = ({style}) => {
  return (<svg style={style} fill="#FFFFFF" height="16" viewBox="0 0 24 24" width="16">
    <path d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"/>
    <path d="M0 0h24v24H0z" fill="none"/>
</svg>)
}


// WEBPACK FOOTER //
// ./src/lib/themes/lingk/FileTable.js